import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from './useAuthContext';

/**
 * Fecha as rotas da seção de Notas Fiscais para quem está fora da audiência.
 *
 * Lê `user.nfseEnabled`, e não `user.experimental_features`, porque aquela lista
 * viaja dentro do payload cacheado do `/user/` — TTL de uma hora, sem
 * invalidação quando o M2M muda. O `nfseEnabled` é recalculado pós-cache pelo
 * `live_feature_flags`, então entrar ou sair da audiência vale no próximo page
 * load. É o mesmo motivo pelo qual o `ExperimentalFeatureGuard` não serve aqui.
 *
 * `Boolean` explícito: enquanto o backend não expõe o campo — ou antes de o
 * usuário carregar — ele vem `undefined`, e esconder é o lado seguro de errar.
 */
export default function NfseFeatureGuard({ children }) {
  const { user } = useAuthContext();

  if (!user?.nfseEnabled) {
    return <Navigate to="/403" replace />;
  }

  return children;
}

NfseFeatureGuard.propTypes = {
  children: PropTypes.node,
};
